// =============================================
// COMPONENTE: VEHICLE NODE
// =============================================
// Arquivo: VehicleNode.tsx
// Descrição: Nó para operações com veículos
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Package } from 'lucide-react';
import ActionsBadge from './ActionsBadge';

const VehicleNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { label, operation, vehicleId, description, actions } = data;

  const getOperationLabel = (op: string) => {
    const labels: Record<string, string> = {
      get: 'Buscar',
      update: 'Atualizar',
      list: 'Listar'
    };
    return labels[op] || op;
  };

  return (
    <div className={`flow-node vehicle-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} className="flow-handle" />

      <div className="node-header vehicle-header">
        <Package className="node-icon" size={18} />
        <span className="node-title">{label || 'Veículo'}</span>
      </div>

      <div className="node-body">
        {operation && (
          <div className="node-field">
            <span className="field-label">Operação:</span>
            <span className="field-value">{getOperationLabel(operation)}</span>
          </div>
        )}
        {vehicleId && (
          <div className="node-field">
            <span className="field-label">Placa/ID:</span>
            <span className="field-value code">{vehicleId}</span>
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle type="source" position={Position.Bottom} className="flow-handle" />
    </div>
  );
};

export default VehicleNode;
